
import { supabase } from "@/integrations/supabase/client";

export const ensureStorageBuckets = async () => {
  try {
    const { data: buckets } = await supabase.storage.listBuckets();
    
    console.log('Available storage buckets:', buckets?.map(b => b.name));
    
    // Check for cms-images bucket - user has already created it in the Supabase dashboard
    if (!buckets?.find(bucket => bucket.name === 'cms-images')) {
      console.log('Warning: cms-images bucket not found. Please create it in the Supabase dashboard.');
    } else {
      console.log('cms-images bucket found!');
    }

  } catch (error) {
    console.error('Error checking storage buckets:', error);
  }
};

// This function is kept for reference but not used since we're using dashboard-created bucket
// and policies should be set up in the dashboard
export const setupStoragePermissions = async () => {
  try {
    console.log('Note: Storage policies should be configured in the Supabase dashboard.');
    console.log('Make sure the cms-images bucket has appropriate read/write policies.');
  } catch (err) {
    console.error('Error with storage policies:', err);
  }
};
